export class Pastilles {
    pastillesEvenements = 0
    pastillesPMN = 0
    pastillesFormulairesReponses = 0
    pastillesDemandesFacturation = 0
    pastillesDemandesDuplicataFicheImplantation = 0
}
